// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nh-5";
export var filledCircle = "_nh-4";
export var historyEntry = "_nh-3";
export var messageSideLeft = "_nh-1";
export var messageSideRight = "_nh-2";
export var orderTrackingCarouselWrapper = "_nh-6";
export var orderTrackingInfoContainer = "_nh-0";